export const votesData = [
  {
    "state": "Assam",
    "total_population": 35607039,
    "voters": {
      "total": 25054463,
      "male": 12531552,
      "female": 12522593,
      "others": 318
    },
    "assembly_seats": 126,
    "area_sq_km": 78438,
    "districts": 35
  },
  {
    "state": "Kerala",
    "total_population": 35699443,
    "voters": {
      "total": 27000000,
      "male": 13100000,
      "female": 13800000,
      "others": 277
    },
    "assembly_seats": 140,
    "area_sq_km": 38863,
    "districts": 14
  },
  {
    "state": "Tamil Nadu",
    "total_population": 77841267,
    "voters": {
      "total": 56700000,
      "male": 27700000,
      "female": 28900000,
      "others": 7617
    },
    "assembly_seats": 234,
    "area_sq_km": 130058,
    "districts": 38
  },
  {
    "state": "West Bengal",
    "total_population": 91276115,
    "voters": {
      "total": 64400000,
      "male": 32800000,
      "female": 31600000,
      "others": 1152
    },
    "assembly_seats": 294,
    "area_sq_km": 88752,
    "districts": 23
  },
  {
    "state": "Puducherry",
    "total_population": 1646050,
    "voters": {
      "total": 944000,
      "male": 443000,
      "female": 500000,
      "others": 139
    },
    "assembly_seats": 30,
    "area_sq_km": 479,
    "districts": 4
  }
]